export var FormLabel = {
    baseStyle: {
        fontSize: 'md',
        color: 'brand.black',
    },
    sizes: {},
    variants: {},
    defaultProps: {},
};
